import React, { useState, useEffect, useRef } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField,useTheme, useMediaQuery} from "@mui/material";
import RoomIcon from '@mui/icons-material/Room';

const GoogleMapModal = ({ open, handleClose, onLocationSelect, initialCenter ,language, keywordsData }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const [map, setMap] = useState(null);
  const [center, setCenter] = useState(initialCenter || { lat: 30.0444, lng: 31.2357 });
  const [locationName, setLocationName] = useState(initialCenter?.address || "");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (map && initialCenter) {
      map.setCenter(initialCenter);
      setCenter(initialCenter);
      setLocationName(initialCenter.address);
    }
  }, [map, initialCenter]);

  useEffect(() => {
    if (!open) return; // ✅ Prevents running when modal is closed

    const loadGoogleMaps = () => {
      if (!mapRef.current) return;
      if (!window.google || !window.google.maps) {
        console.error("Google Maps API is not loaded yet.");
        return;
      }
      
      const newMap = new window.google.maps.Map(mapRef.current, {
        center: center,
        zoom: 15,
        disableDefaultUI: true,
      });

      newMap.addListener("dragend", () => {
        const newCenter = newMap.getCenter();
        setCenter({ lat: newCenter.lat(), lng: newCenter.lng() });
        getAddress(newCenter.lat(), newCenter.lng());
      });

      setMap(newMap);
    };

    if (!window.google || !window.google.maps) {
      var api = 'AIzaSyBl9P55wDymA5tQzFgWFaZWgMyQMdOSWXA';
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${api}&libraries=places&language=${language}`;
      script.async = true;
      script.onload = loadGoogleMaps;
      document.body.appendChild(script);
      api = '';
    } else {
      setTimeout(loadGoogleMaps, 300); // ✅ Delay map reinitialization
    }

    return () => {
      setMap(null); // ✅ Cleanup: Reset map when modal closes
    };
  }, [open]);

  // Reverse Geocoding (LatLng → Address)
  const getAddress = (lat, lng) => {
    if (!window.google || !window.google.maps) {
      console.error("Google Maps API is not loaded yet.");
      return;
    }
  
    const geocoder = new window.google.maps.Geocoder();
    const latlng = { lat, lng };
    
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === "OK" && results[0]) {
        setLocationName(results[0].formatted_address);
      } else {
        setLocationName(language === 'ar' ? keywordsData.location_not_found_txt_ar : keywordsData.location_not_found_txt_en);
      }
    });
  };
  

  const handleConfirmLocation = () => {
    onLocationSelect({ lat: center.lat, lng: center.lng, address: locationName });
    localStorage.setItem('is_check_location','true');
    handleClose();
  };

  return (
     <Dialog open={open} onClose={handleClose} 
       maxWidth="md" 
  fullWidth 
  fullScreen={isMobile}
  dir={language === 'ar' ? 'rtl' : 'ltr'}
  PaperProps={{
    sx: {
      backgroundColor: '#0D0D0D',
      background: 'linear-gradient(135deg, #0D0D0D 0%, #1A1A1A 100%)',
      border: '1px solid rgba(255, 215, 0, 0.2)',
      borderRadius: isMobile ? 0 : '24px',
      boxShadow: '0 20px 40px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,215,0,0.1)',
      overflow: 'hidden',
      position: 'relative',
    }
  }}>   
     <DialogTitle>{language === "ar" ? "موقع التوصيل" : "Delever location"}</DialogTitle>
      <DialogContent>
        {/* Search Bar for Showing Selected Location Name */}
        <TextField
          fullWidth
          value={locationName}
          variant="outlined"
          placeholder={language === "ar" ? "ابحث عن منطقة، شارع، معلم معروف..." : "Search for an area, street, landmark..."}
          disabled
          style={{ marginBottom: "10px" }}
        />

        <div style={{ height: "400px", position: "relative" }}>
          <div ref={mapRef} style={{ width: "100%", height: "100%" }} />
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -100%)",
              fontSize: "40px", // Increase Pin Size
            }}
          >
            <RoomIcon style={{color:'#FFD700' ,fontSize:35}}/>
          </div>
        </div>
        
        <Button
          fullWidth
          variant="contained"
          color="inherit"
          style={{ marginTop: "10px", background: "#FFD700" }}
          onClick={handleConfirmLocation}
        >
            {language === "ar" ? "وصل هنا" : "Deleiver here"}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default GoogleMapModal;
